const React = require('react')
const { component } = require('../odo/odojs')
const inject = require('injectinto')
const route = require('odo-route')
const { useEffect } = require('react')

route('/sso/azure-ad/test/', ({ params, querystring }) => {
  const r = { page: 'login:sso:test', type: params.type }
  querystring.split('&').forEach(p => {
    const [k, v] = p.split('=')
    r[k] = v
  })
  return r
})

inject.bind(
  'page:login:sso:test',
  component({
    render: (state, params, hub) => {
      document.title = 'Asset Altitude'

      useEffect(() => {
        hub.emit('test azure auth')
      }, [])

      return <div className='page--wrapper'></div>
    }
  })
)
